<template>
  <div>
    <div v-if="stage && loaded">
      <div class="flex">
        <div>
          <Unit :unit="$parent.player" />
        </div>

        <div v-if="!recover">
          <Unit :unit="enemy" />
        </div>
      </div>
    </div>
    <div v-else>
      <h1>Loading</h1>
    </div>
  </div>
</template>
    
<script>
import {
  checkUnfocusTime,
  getDiff,
  setGuys,
  setTick,
  setReset,
  setClock,
} from "@/functions/ticker.js";

import { Stage } from "@/functions/klassen";

import Unit from "@/components/Unit";

export default {
  data() {
    return {
      stage: null,
      enemy: null,
      ticker: null,
      recover: false,
      loaded: false,
    };
  },
  components: {
    Unit,
  },
  methods: {
    init() {
      this.stage = new Stage(this.$route.params.id);
      this.enemy = this.stage.SpawnEnemy();
      setReset(this.respawn);
      setGuys([this.$parent.player, this.enemy]);
      this.ticker == null && (this.ticker = setInterval(this.update, 100));
      this.loaded = true;
    },
    update() {
      checkUnfocusTime(this.updateLogicStuff);
      this.updateLogicStuff();
      this.$parent.player.timestamp = new Date();
    },
    updateLogicStuff() {
      if (this.recover) {
        if (this.$parent.player.recover()) {
          this.enemy = this.stage.SpawnEnemy();
          setGuys([this.$parent.player, this.enemy]);
          this.recover = false;
        }
      } else {
        setTick();
      }
    },
    checkAfk() {
      return new Promise((resolve) => {
        let diff = getDiff();
        if (diff >= 1) {
          setClock(diff);
        }
        resolve();
      });
    },
    respawn(player = false) {
      if (!player) {
        this.enemy.getReward(this.$parent.player);
        this.enemy = this.stage.SpawnEnemy();
        this.enemy.scaleEnemy(this.$parent.player.level);
        setGuys([this.$parent.player, this.enemy]);
      } else {
        this.$parent.player.ctick = 0;
        this.$parent.player.hp = 0;
        this.$parent.player.buffs = [];
        this.recover = true;
      }
    },
  },
  destroyed() {
    clearInterval(this.ticker);
  },
  mounted() {
    this.checkAfk().then(() => {
      this.init();
    });
  },
};
</script>
    
<style scoped>
.flex {
  margin: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.kiste {
  display: flex;
  flex-direction: column;
  background: lightslategray;
  border: 1px solid black;
  padding: 10px;
  align-items: center;
}
.spell {
  border: 1px solid black;
  padding: 10px;
  margin: 5px;
  background: lightgray;
}
.spellist {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
}
</style>